import React from 'react';
import { Link } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import HomeCard from '../shared/HomeCard';
import { familySegments } from '../config/familySegments';

export default function FamilySegmentationFramework() {
  return (
    <div className="page">
      <Link to="/family-dashboard" className="back-link">
        <ArrowBackIcon fontSize="small" /> Back to Family Dashboard
      </Link>
      <div className="page-header">
        <h1 className="page-title">Family-Based Household Segmentation Framework</h1>
        <p className="page-subtitle">Household segments used to target and prioritise family-level interventions.</p>
      </div>

      <div className="card-grid">
        {familySegments.map((segment) => (
          <HomeCard
            key={segment.id}
            to={`/family-dashboard/segmentation-framework/${segment.id}`}
            title={segment.title}
            icon={segment.icon}
            accent={segment.accent}
          />
        ))}
      </div>
    </div>
  );
}
